import styled, { css } from 'react-emotion';
import './WidgetReset';
import { Wrapper as w1 } from '../Components/WidgetSuggest/styles'
import { Title, Link } from '../Components/WidgetMunicipalCount/styles'

export const wrapperCentrum = css`
	min-height: 0;
	max-height: 268px;
	${w1} {
		margin-top: 0;
	}
	${Title} + ${Link} {
		margin-bottom: 0;
	}
`;

export const flexContainer = css`
	align-items: center;
	display: flex;
	justify-content: space-between;
`;

export const center = css`
	text-align: center;
`;


export const centrumBackground = css`
	background: #00467f;
`;

export const TextLink = styled.a`
	color: #595959;
	font-size: 0.875rem;
	font-weight: normal;
`;
